var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.customStyle)},[(_vm.type !== 'none')?_c('img',{class:_vm.classByType,attrs:{"alt":"background","src":_vm.imgUrl}}):_vm._e(),_c('div',{staticClass:"background-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }